<template>
  <v-card flat>
    <v-card-text>
      <div>Receipt # {{ invoice.number }}</div>
      <div
        v-for="item in invoice.items"
        :key="item._id"
      >
        <div>{{ item.name }}</div>
        <div>{{ item.description }}</div>
        <div>{{ `${item.qty} x $${(item.price * .01).toFixed(2)} = $${(item.amount * .01).toFixed(2)}` }}</div>
      </div>
      <div>$ {{ (invoice.total * .01).toFixed(2) }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed:{
      invoice(){return this.$store.state.market.invoice || {}}
  },
  methods: {
    continueShopping(){
      this.$router.push(`/${this.$route.path.split('/')[1]}`)
    },
  }
}
</script>